import React, { useContext, useEffect, useRef } from "react";
import styled from "styled-components";
import Theme from "../../util/globals/Theme";
import { H3 } from "../../styles/shared/typography";
import Flex from "../../util/GridJitsu/Flex";
import attachmentIcon from '../../assets/images/attachment-white.svg'
import attachmentBlueIcon from '../../assets/images/attachment-blue.svg'

import closeWhite from "../../assets/icon-colors/base-icons/close-white.svg";
import closeX from "../../assets/icon-colors/base-icons/close-x.svg";
import closeH from "../../assets/icon-colors/base-icons/closehover.svg";
import SelectIndicationContext from "../../context/SelectIndicationContext";
import { createGlobalStyle } from "styled-components";
import { respondTo } from "../../styles/shared/breakpoints";
import Button from "../Button";

const GlobalStyles = createGlobalStyle`
  #selectConditionOverlay {
   z-index: 32;
   background: var(--Gradients-Blue-Gradient, linear-gradient(90deg, #2E3790 12.56%, #3D82C3 100%));
// box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
box-shadow: none;

  }
`;

const Root = styled.div`
  height: 100%;
  width: 100%;
  max-width: unset;
  position: fixed;
  top: 25px;
  padding-bottom: 40px;
  box-shadow: 0 2px 6px 0 rgb(0 0 0 / 40%);
  left: 0;
  visibility: ${({ visible }) => (visible ? `visible` : `hidden`)};
  opacity: ${({ visible }) => (visible ? `1` : `0`)};
  transition: visibility 0s ease-in-out, opacity 0.2s ease-in-out;
  pointer-events: ${({ visible }) => (visible ? `all` : `none`)};
  // box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.4);
  padding: 32px 10px 25px 10px;

  @media (min-width: ${Theme.breakpoints.lg}px) {
    height: auto;
    width: 984px;
    width: 1032px;
    max-width: calc(100vw - 40px);
    background: ${Theme.colors.white};
    padding: 32px 0;
    position: absolute;
    top: 153px;
    visibility: ${({ visible }) => (visible ? `visible` : `hidden`)};
    opacity: ${({ visible }) => (visible ? `1` : `0`)};
    transition: visibility 0s ease-in-out, opacity 0.2s ease-in-out;
    pointer-events: ${({ visible }) => (visible ? `all` : `none`)};
    // box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.4);
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10 !important;
  }
`;

const StyledMainFlex = styled(Flex)`
  align-items: center;
`;

const ButtonFlex = styled(Flex)`
  width: 100%;

  img {
    padding-top: 21px;
    padding-right: 20px;
  }
`;

const StyledHeaderL = styled.p`
  padding-bottom: 23px;
  color: ${Theme.colors.white};
  text-align: center;
  font-size: 28px;
  font-style: normal;
  font-weight: 800;
  line-height: 130%;
  @media (max-width: ${Theme.breakpoints.md}px) {
    font-size: 24px;
  }
`;

const LinkWrap = styled.div`
  min-width: 293px;
  display:flex;
  align-items-stretch;

  a {
    width: 100%;
  }

  @media (max-width: ${Theme.breakpoints.lg}px) {
    width: 100%;
  }
`;
const LinksWrapper = styled.div`
  display: flex;
flex-direction: column;
  justify-content: center;
  gap: 30px;
  align-items: stretch;
  --multiplier: calc(640px - 100%);
  width: 100%;
  padding: 0px 30px 0px 30px;

  @media (min-width: ${Theme.breakpoints.md}px) {
    flex-direction: row;
    width: unset;
    }
`;

const LinkItem = styled(Button)`
  padding: 20px 45px 20px 20px;
  border-radius: 6px;
  text-align: left;
  justify-content: flex-start;
  align-items: center;
  min-height: 63px;

  ${({ multiButtons }) =>
    multiButtons &&
    `
    flex: 1;
    flex-basis: 0;
    align-self: normal;
  `}
`;

const Close = styled.button`
  font: inherit;
  line-height: normal;
  overflow: visible;
  width: auto;
  margin: 0;
  padding: 0;
  color: inherit;
  border: none;
  background: transparent;
  position: absolute;
  top: 16px;
  right: 30px;
  width: 17px;
  height: 17px;
  cursor: pointer;
  border: none;
  background-image: url(${closeWhite});
  background-color: transparent;
  background-size: 100%;

  @media (min-width: ${Theme.breakpoints.lg}px) {
    display: none;
  }
`;

const OptionButton = styled.a`
    padding: 20px 45px 20px 20px;
    display:flex;
    border-radius: 6px;
    text-align: left;
    -webkit-box-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    background: rgb(255, 255, 255);
    align-items: center;
    min-height: 63px;
    font-size: 16px;
    line-height: 20px;
    color: rgb(46, 55, 144);
    font-weight: 700;
    min-width: 120px;
    margin: 0px;
    overflow: hidden;
    text-decoration: none;
    cursor: pointer;
    border: none;
    transition: background-position 0.2s ease-in-out, color 0.2s ease-in-out;
    position: relative;
    font-family: inherit;

     &::after {
          background-image: url(${attachmentBlueIcon});
          content: "";
          display: block;
          position: absolute;
          top: 0px;
          right: 0px;
          height: 100%;
          width: 44px;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 16px 16px;
        }

      &:hover {
        background: rgb(46, 55, 144);
        color: rgb(255, 255, 255);

        &::after {
         background-image: url(${attachmentIcon}); 
        }
         
      }

}

color: #2C3796; 
font-size: 16px;
font-style: normal;
font-weight: 700;
`;


export default function NavigationLayout({ isOpen, setIsOpen, setNavOpen }) {
  const { setSelectIndication } = useContext(SelectIndicationContext);

  return (
    <>
      <GlobalStyles />
      <Root visible={isOpen} aria-hidden={!isOpen} id="selectConditionOverlay">
        <StyledMainFlex direction="column">
          <ButtonFlex data-design-category="button_vd" justify="flex-end">
            <Close
              aria-label="Close selector"
              onClick={() => {
                setIsOpen(false);
              }}
            ></Close>
          </ButtonFlex>
          <StyledHeaderL>Select a condition</StyledHeaderL>

          <LinksWrapper dataAt="cancer-type-container">
            <LinkWrap
              onClick={() => {
                setSelectIndication("rcc");
                setIsOpen(false);
                setNavOpen(false);
              }}
            >
              <LinkItem
                variant="primaryBlue"
                to="/advanced-renal-cell-carcinoma/"
                alt=""
                continualInverted="true"
              >
                Advanced Clear Cell RCC
              </LinkItem>
            </LinkWrap>

            <LinkWrap
              onClick={() => {
                setSelectIndication("vhl");
                setIsOpen(false);
                setNavOpen(false);
              }}
            >
              <LinkItem
                variant="primaryBlue"
                to="/von-hippel-lindau/"
                alt=""
                continualInverted="true"
              >
               VHL Disease–Associated Tumors
              </LinkItem>
            </LinkWrap>
            <LinkWrap
              // onClick={() => {
              //   setSelectIndication("vhl");
              //   setIsOpen(false);
              //   setNavOpen(false);
              // }}
            >
              {/* <LinkItem
                variant="primaryBlue"
                to={"https://www.merck.com/product/usa/pi_circulars/w/welireg/welireg_pi.pdf"}
                alt=""
                continualInverted="true"
              >
                Advanced Pheochromocytoma or Paraganglioma (PPGL)
              </LinkItem> */}

              <OptionButton continualInverted="true" target="_blank" href="https://www.merck.com/product/usa/pi_circulars/w/welireg/welireg_pi.pdf">Advanced Pheochromocytoma or Paraganglioma (PPGL)</OptionButton>
            </LinkWrap>
          </LinksWrapper>
        </StyledMainFlex>
      </Root>
    </>
  );
}
